'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var players = {
  jplayer: 'jplayer',
  hlsjs: 'hlsjs',
  wmp: 'wmp',
  howler: 'howler'
};

exports.default = players;
//# sourceMappingURL=players.js.map